var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.legend && _vm.legend.length > 0)?_c('q-table',{staticClass:"q-mt-md",attrs:{"title":_vm._f("capitalize")(_vm.$t('names.legend')),"data":_vm.legend,"columns":_vm.columns,"hide-bottom":"","pagination":{
        sortBy: 'desc',
        descending: false,
        rowsPerPage: 10
      }},scopedSlots:_vm._u([{key:"body-cell-color",fn:function(ref){
      var value = ref.value;
return [_c('td',{style:({ 'background-color': value })},[_c('span',{staticClass:"contrast"},[_vm._v(_vm._s(value))])])]}}],null,false,3903347590)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }